import React from 'react';

import { useEFM } from '@/components/Ajax';

export default function useGetCurrentPermissions() {
	return useEFM('/application/permission/current', {}, false, 30000);
}
